import React from 'react'

import EmailPasswordAuthForm from './EmailPasswordAuthForm'

import './AppAuth.scss'

export interface AppAuthProps {
  onAuth?: Function
}

export default function AppAuth ({ onAuth }: AppAuthProps) {
  return (
    <div className="AppAuth__container">
      <div className="AppAuth">
        <div className="AppAuth__Header">
          <h1 className="AppAuth__Title">HIVE</h1>
          <small className="AppAuth__Description">
            вход в панель администратора
          </small>
        </div>
        <EmailPasswordAuthForm onAuth={onAuth} />
      </div>
    </div>
  )
}
